import { render, staticRenderFns } from "./ColaS.vue?vue&type=template&id=283e0da0&scoped=true"
import script from "./ColaS.vue?vue&type=script&lang=js"
export * from "./ColaS.vue?vue&type=script&lang=js"
import style0 from "./ColaS.vue?vue&type=style&index=0&id=283e0da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e0da0",
  null
  
)

export default component.exports